// Note this is what updateLoan funciton should have looked like
// but no pattern was established before

async function updateLoan2(user, loanID, dataToUpdate) {
  // for security reasons to compare those value on backend
  // const targetUrl = `${process.env.CMS_URL}/tours/${tour.id}/?TourID=${tour.id}&UserType=${userType}&UrlAddress=${tour.UrlAddress}`;
  // all the query params need to be provided

  const targetUrl = `${process.env.CMS_URL}/loans/${loanID}`;
  const token = await user.getIdToken();
  // dataTranslation
  const res = await fetch(targetUrl, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(dataToUpdate),
  });

  const respJSON = await res.json();

  return respJSON;
}

export default updateLoan2;
